import { Lang } from '../../typings/common';
import { LangUtils } from '../Lang/Lang';
/**
 * Возвращает слово в склонении, соответсвующем числу, переданному в параметрах
 * @param {Array} forms формы слова [1, 2, 5]
 * @param {Number} count количество
 * @example pluralizeWord(['яблоко', 'яблока', 'яблок'], 5) => 'яблок'
 */
export function pluralizeLocalWord<T>(
    forms: T[],
    count: number,
    lang: Lang = Lang.ru
): T {
    if (lang === Lang.ru || lang === Lang.uk) {
        count = count % 100;

        if (count >= 5 && count <= 20) {
            return forms[2];
        }

        count = count % 10;

        if (count === 1) {
            return forms[0];
        } else if (count < 5 && count > 0) {
            return forms[1];
        }

        return forms[2];
    } else if (lang === Lang.en || lang === Lang.tr) {
        if (count === 1) {
            return forms[0];
        }

        return forms[1];
    }

    throw new Error(
        `Language ${lang} is not supported by PluralizeWord function`
    );
}

/**
 * Возвращает слово в склонении, соответсвующем числу, переданному в параметрах для текущего языка
 * @param {Array} forms формы слова [1, 2, 5]
 * @param {Number} count количество
 * @example pluralizeWord(['яблоко', 'яблока', 'яблок'], 5) => 'яблок'
 */
export function pluralizeWord<T>(forms: T[], count: number): T {
    return pluralizeLocalWord(forms, count, LangUtils.getCurrentLang());
}
